import { RestClient } from '@libs/rest-client';
import {
  hoMstDelete,
  hoMstExport,
  hoMstFetch,
  hoMstImport,
  hoMstListRequest,
  hoMstRegistration,
  hoMstUpdate,
} from '@libs/templates/mst';
import {
  LocationMstListSearchRaw,
  LocationMstRegistration,
  LocationMstRegistrationRaw,
  LocationMstSetting,
  LocationMstSettingRaw,
} from '../models';

const LOCATION_MST_URL = '/location-mst';

const register = hoMstRegistration(LOCATION_MST_URL, LocationMstRegistrationRaw)();

const listRequest = hoMstListRequest(LOCATION_MST_URL, LocationMstListSearchRaw, LocationMstRegistration)();

const doExport = hoMstExport(LOCATION_MST_URL, LocationMstListSearchRaw)();

const fetchMst = hoMstFetch(LOCATION_MST_URL, LocationMstRegistration)();

const update = hoMstUpdate(LOCATION_MST_URL, LocationMstRegistrationRaw)();

const remove = hoMstDelete(LOCATION_MST_URL)();

const importFunction = hoMstImport(LOCATION_MST_URL)();

async function fetchLocationMstSetting() {
  return LocationMstSetting.fromRaw(
    await RestClient.fa.get<LocationMstSettingRaw>(`${LOCATION_MST_URL}/setting`),
  );
}

async function registerSetting(setting: LocationMstSetting, defaultName: string) {
  await await RestClient.fa.put(
    `${LOCATION_MST_URL}/setting`,
    LocationMstSettingRaw.fromModel(setting, defaultName),
  );
}

export {
  doExport,
  fetchLocationMstSetting,
  fetchMst,
  importFunction,
  listRequest,
  register,
  registerSetting,
  remove,
  update,
};
